import { useMemo } from 'react'
import type { WidgetConfig } from '@/types'

// ─────────────────────────────────────────────
// useWidgetConfig
// Reads configuration injected by loader.js into
// the iFrame URL as query parameters.
//
// loader.js builds the iFrame src like:
// https://widget.dirayah.ai/?mode=embed
//   &tenant=acme-corp&domain={guid}
//   &lang=English&theme=light&title=HR+Assistant
//
// In standalone mode (direct URL access),
// these params can be passed manually for testing.
// ─────────────────────────────────────────────
export function useWidgetConfig(): WidgetConfig {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search)

    const apiUrl = params.get('apiUrl') || ''  // Empty = use Vite proxy in dev

    return {
      tenantSlug:      params.get('tenant')   || 'demo',
      tenantId:        '',   // ← ADD — populated after auth, empty on init
      domainId:        params.get('domain')   || '',
      widgetApiKey:    params.get('apiKey')    || '',  // ← NEW
      apiUrl,
      theme:           (params.get('theme')   || 'light') as 'light' | 'dark',
      defaultLanguage: params.get('lang')     || 'English',
      title:           params.get('title')    || 'DirayahAI Assistant',
      logoUrl:         params.get('logo')     || undefined,
    }
  }, []) // Params don't change during widget lifetime — compute once
}